import type { RouterLocale } from '~shared/constants/i18n';

export const getFormattedDate = ({
	date,
	locale,
	month,
}: {
	date?: string;
	locale: RouterLocale;
	month?: Intl.DateTimeFormatOptions['month'];
}) =>
	date
		? new Intl.DateTimeFormat(locale, {
				year: 'numeric',
				month: month || 'numeric',
				day: 'numeric',
		  }).format(new Date(date))
		: 'unknown';
